/* Каркас загрузки в трёх раскладках и два экрана состояния: сбой и отсутствие прав. */

.frame {
  display: flex;
  height: 100%;
  overflow: hidden;
  background: var(--bg-workspace);
}

.frameNav {
  flex: none;
  width: var(--nav-width);
  padding: var(--space-3) var(--space-2);
  background: var(--bg-nav);
}

.frameNavIcons {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: var(--space-1);
  align-items: center;
  width: var(--nav-width-icon);
  padding: var(--space-3) 0;
  background: var(--bg-nav);
}

/*
 * Плашки навигации светятся НА бордовом фоне, а не на рабочем: общий .plnr-skeleton
 * взял бы цвет провала и на навигации был бы чёрным пятном. Поэтому у них свой фон
 * и своя анимация — та же самая, из base.css.
 */
.navPlate {
  height: 14px;
  margin-bottom: 9px;
  background: var(--bg-nav-active);
  border-radius: var(--radius-sm);
  animation: plnr-skeleton 1.4s infinite;
}

.navIconPlate {
  width: 40px;
  height: 36px;
  background: var(--bg-nav-active);
  border-radius: var(--radius-md);
  animation: plnr-skeleton 1.4s infinite;
}

@media (prefers-reduced-motion: reduce) {
  .navPlate,
  .navIconPlate {
    animation: none;
  }
}

.frameBody {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.frameTopbar {
  display: flex;
  flex: none;
  gap: var(--space-3);
  align-items: center;
  height: var(--topbar-height);
  padding: 0 var(--space-4);
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
}

.frameToolbar {
  display: flex;
  flex: none;
  gap: 10px;
  align-items: center;
  height: var(--toolbar-height);
  padding: 0 var(--space-4);
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
}

/* Подпись «Проверяем доступ…» держится тихой намеренно: это обычная загрузка,
   а не предупреждение. Человек с доступом не должен заподозрить, что его проверяют. */
.checkingNote {
  margin-left: auto;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}

.grid {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.gridScale {
  flex: none;
  width: var(--grid-time-column);
  border-right: 1px solid var(--border);
}

.gridHour {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  height: 52px;
  padding: 2px var(--space-2) 0 0;
  font-size: var(--font-size-xs-plus);
  font-variant-numeric: tabular-nums;
  color: var(--text-faint);
}

.gridColumn {
  position: relative;
  flex: 1;
  min-width: 0;
  border-right: 1px solid var(--border);
}

.gridHead {
  display: flex;
  gap: 7px;
  align-items: center;
  height: var(--grid-master-header);
  padding: 0 var(--space-2);
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-strong);
}

.gridHeadText {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.gridBlock {
  position: absolute;
  right: 3px;
  left: 5px;
  border-radius: var(--radius-sm);
}

/* ─────────── телефон ─────────── */

.phoneFrame {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: var(--bg-workspace);
}

.phoneHead {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: var(--space-1);
  padding: 10px var(--space-4) var(--space-2);
}

.checkingRow {
  flex: none;
  padding: 0 var(--space-4);
  font-size: var(--font-size-xs-plus);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.08em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.phoneList {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-2);
  min-height: 0;
  padding: var(--space-2) var(--space-4);
  overflow: hidden;
}

.phoneCard {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 7px;
  padding: 10px var(--space-3);
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}

.phoneTabbar {
  display: flex;
  flex: none;
  height: var(--mobile-tabbar-height);
  background: var(--bg-card);
  border-top: 1px solid var(--border);
}

.phoneTab {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}

/* ─────────── сбой и отказ ─────────── */

.centered {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: var(--space-6);
  text-align: center;
}

.card {
  max-width: 460px;
  padding: 12px 14px;
  text-align: left;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-left: 3px solid var(--danger-hover);
  border-radius: var(--radius-md);
}

.cardTitle {
  margin: 0 0 var(--space-1);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
}

.cardText {
  margin: 0;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}

.cardActions {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  margin-top: var(--space-3);
}

.trace {
  padding: 6px var(--space-2);
  margin-top: var(--space-2);
  font-family: ui-monospace, "SFMono-Regular", Consolas, monospace;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  background: var(--bg-sunken);
  border-radius: 6px;
}

.denied {
  max-width: 420px;
  text-align: left;
}
